import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { getDefaultThemeType } from '../../themes/themeUtil'

const BackgroundProviderContext = createContext({
  background: getDefaultThemeType() === 'dark' ? 'var(--root-bg-color, black)' : 'var(--root-bg-color, white)'
})

export const useBackgroundContext = () => {
  return useContext(BackgroundProviderContext)
}

function BackgroundProvider ({ children }) {
  // const bodyRef = useRef(document.body)
  const [bg, setBg] = useState([{
    bg: getDefaultThemeType() === 'dark' ? 'var(--root-bg-color, black)' : 'var(--root-bg-color, white)',
    key: 'inital'
  }])
  const setBackground = useCallback((background) => {
    setBg((prev) => {
      return [prev.at(-1), { bg: background, key: Math.random().toString(16) }]
    })
  }, [])

  const providerValue = useMemo(() => {
    return {
      setBackground
    }
  }, [setBackground])

  return (
    <BackgroundProviderContext.Provider value={providerValue}>
      {bg.map((item, index) => (
        <div
          key={`background_${item.key}`}
          id={`background_${item.key}`}
          style={{
            animationName: index === 0 ? 'animation-fade-out' : 'animation-fade-in',
            animationDuration: index === 0 ? '3s' : '1s',
            animationFillMode: 'forwards',
            animationEasing: 'ease-in-out',
            position: 'absolute',
            minWidth: '100vw',
            width: '100%',
            height: '100%',
            minHeight: '100%',
            zIndex: -1,
            opacity: 0,
            top: 0,
            margin: 0,
            backgroundSize: 'cover',
            background: item.bg
          }}
        />
      ))}
      {children}
    </BackgroundProviderContext.Provider>
  )
}

BackgroundProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default BackgroundProvider
